import { Grid, Paper, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

export default function MySubmissionsFilters({
    formFilter,
    formOptions,
    onFormFilterChange
}) {
    return (
        <Paper
            elevation={0}
            sx={{
                mb: 2,
                mt: 2,
                px: { xs: 1.5, sm: 3 },
                py: { xs: 2, sm: 2.5 },
                borderRadius: 2,
                border: '1px solid #e0e0e0',
                backgroundColor: '#fafafa',
            }}
        >
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={12} md={4}>
                    <FormControl size="small" fullWidth sx={{ minWidth: 280 }}>
                        <InputLabel shrink sx={{ fontWeight: 700 }}>Filter by Form</InputLabel>
                        <Select
                            value={formFilter}
                            onChange={onFormFilterChange}
                            displayEmpty
                            label="Filter by Form"
                            notched
                        >
                            <MenuItem value="">All forms</MenuItem>
                            {formOptions.map((opt) => (
                                <MenuItem key={opt.value} value={opt.value}>
                                    {opt.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
        </Paper>
    );
}